import { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

const getQueryStringValue = (
  key: string,
  queryString = window.location.search
) => {
  const searchParams = new URLSearchParams(queryString);
  return searchParams.get(key);
};

export const useQueryString = (
  key: string,
  initialValue: string
): [string, (newValue: string) => void] => {
  const history = useHistory();

  const [value, setValue] = useState<string>(
    getQueryStringValue(key) || initialValue
  );

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);
    if (value) {
      params.delete(key);
      params.append(key, value);
    } else {
      params.delete(key);
    }
    history.push({ search: params.toString() });
  }, [value, history]);

  const onSetValue = useCallback(
    (newValue) => {
      setValue(newValue);
    },
    [key]
  );

  return [value, onSetValue];
};

export default useQueryString;
